// GENERATED FILE — DO NOT EDIT BY HAND.
// scripts/generate-demo-dataset/generate.mjs · spec docs/DVA_Demo_Dataset_Generation_Spec_v1.md v1.1
//
// Wave 1. Keyed by DEMO OPPORTUNITY ID — what the router and OPP_TO_UC resolve. The stage and
// AP-DVA use-case ids do not align with each other, so both live in each module's provenance.
import type { GeneratedUcRationale } from './types';
import { UC_RATIONALE_OPP_10 } from './ucRationale_opp-10';
import { UC_RATIONALE_OPP_2 } from './ucRationale_opp-2';
import { UC_RATIONALE_OPP_3 } from './ucRationale_opp-3';
import { UC_RATIONALE_OPP_4 } from './ucRationale_opp-4';
import { UC_RATIONALE_OPP_9 } from './ucRationale_opp-9';
import { UC_RATIONALE_OPP_6 } from './ucRationale_opp-6';
import { UC_RATIONALE_OPP_8 } from './ucRationale_opp-8';
import { UC_RATIONALE_OPP_11 } from './ucRationale_opp-11';
import { UC_RATIONALE_OPP_13 } from './ucRationale_opp-13';
import { UC_RATIONALE_OPP_14 } from './ucRationale_opp-14';
import { UC_RATIONALE_OPP_15 } from './ucRationale_opp-15';
import { UC_RATIONALE_OPP_16 } from './ucRationale_opp-16';
import { UC_RATIONALE_OPP_17 } from './ucRationale_opp-17';
import { UC_RATIONALE_OPP_18 } from './ucRationale_opp-18';
import { UC_RATIONALE_OPP_19 } from './ucRationale_opp-19';
import { UC_RATIONALE_OPP_20 } from './ucRationale_opp-20';
import { UC_RATIONALE_OPP_21 } from './ucRationale_opp-21';
import { UC_RATIONALE_OPP_22 } from './ucRationale_opp-22';
import { UC_RATIONALE_OPP_23 } from './ucRationale_opp-23';

export type { GeneratedUcRationale, GeneratedMeasure, GeneratedProvenance } from './types';

export const GENERATED_RATIONALE: Record<string, GeneratedUcRationale> = {
  "opp-10": UC_RATIONALE_OPP_10,
  "opp-2": UC_RATIONALE_OPP_2,
  "opp-3": UC_RATIONALE_OPP_3,
  "opp-4": UC_RATIONALE_OPP_4,
  "opp-9": UC_RATIONALE_OPP_9,
  "opp-6": UC_RATIONALE_OPP_6,
  "opp-8": UC_RATIONALE_OPP_8,
  "opp-11": UC_RATIONALE_OPP_11,
  "opp-13": UC_RATIONALE_OPP_13,
  "opp-14": UC_RATIONALE_OPP_14,
  "opp-15": UC_RATIONALE_OPP_15,
  "opp-16": UC_RATIONALE_OPP_16,
  "opp-17": UC_RATIONALE_OPP_17,
  "opp-18": UC_RATIONALE_OPP_18,
  "opp-19": UC_RATIONALE_OPP_19,
  "opp-20": UC_RATIONALE_OPP_20,
  "opp-21": UC_RATIONALE_OPP_21,
  "opp-22": UC_RATIONALE_OPP_22,
  "opp-23": UC_RATIONALE_OPP_23,
};

/**
 * Tier A use cases served by a HAND-BUILT fixture rather than a generated module — today just
 * the hero, whose delta card, priority themes and 3-item evidence come from stage tables outside
 * the wave-1 extracts (ccRationaleStage.ts). Without this they would read as Tier C.
 */
export const HAND_BUILT_TIER_A: readonly string[] = ["opp-1"];

/** Tier for any demo opportunity. Anything with no fixture at all is Tier C (spec §5). */
export function generatedTierFor(oppId: string): "A" | "B" | "C" {
  if (HAND_BUILT_TIER_A.includes(oppId)) return "A";
  return GENERATED_RATIONALE[oppId]?.tier ?? "C";
}
